import React, { Fragment } from 'react';

export default function Label({ text }) {
	return (
		<Fragment>
			{text && <label className="w-full form-label font-bold inline-block mt-1 text-gray-700">{text}</label>}
		</Fragment>
	);
}
